import { render, staticRenderFns } from "./AppDecorMenu.vue?vue&type=template&id=befa3910&scoped=true"
import script from "./AppDecorMenu.vue?vue&type=script&lang=js"
export * from "./AppDecorMenu.vue?vue&type=script&lang=js"
import style0 from "./AppDecorMenu.vue?vue&type=style&index=0&id=befa3910&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "befa3910",
  null
  
)

export default component.exports